import classes from "./TcAndPrivacy.module.scss";
import TcAndPrivacySidebar from "./TcAndPrivacySidebar/TcAndPrivacySidebar";

type Props = {
  title: string;
  content: any[];
};

function TcAndPrivacy(props: Props) {
  const { title, content } = props;

  return (
    <div className={classes.container}>
      <div className={classes.title}>{title}</div>

      <div className={classes["contemt-container"]}>
        <TcAndPrivacySidebar
          items={content.map((item) => ({
            id: item.id,
            header: item.header,
          }))}
        />

        <div className={classes.content}>
          {content.map((item, index) => (
            <div key={index} id={item.id}>
              <div className={classes.header}>{item.header}</div>

              {item.content}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TcAndPrivacy;
